import { render, staticRenderFns } from "./team-edit.vue?vue&type=template&id=1750ec7b&scoped=true"
import script from "./team-edit.vue?vue&type=script&lang=js"
export * from "./team-edit.vue?vue&type=script&lang=js"
import style0 from "./team-edit.vue?vue&type=style&index=0&id=1750ec7b&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1750ec7b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/graphileon/graphileon/release/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1750ec7b')) {
      api.createRecord('1750ec7b', component.options)
    } else {
      api.reload('1750ec7b', component.options)
    }
    module.hot.accept("./team-edit.vue?vue&type=template&id=1750ec7b&scoped=true", function () {
      api.rerender('1750ec7b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/renderers/team-edit-view-renderer/team-edit.vue"
export default component.exports